import React from 'react'
import PropTypes from 'prop-types'

import DisplayCash from './DisplayCash'
import DisplayPoints from './DisplayPoints'

import yn from 'yn'

const PriceLabel = ({ isOnlyCash, hasDiscount, regularPrice, price, cash, currency }) => (
  <div className='card-price col-12 mt-1 mb-1 color-brand-1 p-0'>
    <div className='row align-items-center h-100'>
      <div className='card-price-item col-12 px-0 z-p-0'>
        <div className='row'>
          {isOnlyCash
            ? <DisplayCash {...cash} />
            : (
              <DisplayPoints
                hasDiscount={yn(process.env.REACT_APP_HAS_DISCOUNT) || hasDiscount}
                regularPrice={regularPrice}
                price={price}
                currency={currency}
              />
            )
          }
        </div>
      </div>
    </div>
  </div>
)

PriceLabel.propTypes = {
  hasDiscount: PropTypes.bool,
  regularPrice: PropTypes.number,
  price: PropTypes.number.isRequired,
  cash: PropTypes.shape({
    price: PropTypes.number.isRequired
  }),
  currency: PropTypes.shape({
    decimalPlaces: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  isOnlyCash: PropTypes.bool
}

PriceLabel.defaultProps = {
  hasDiscount: false,
  currency: {
    decimalPlaces: 2,
    name: 'pontos'
  }
}

export default PriceLabel



// WEBPACK FOOTER //
// ./src/features/Availability/ProductCard/ProductAvailability/PriceLabel/PriceLabel.js